import { useSelector } from "react-redux";
import { Typography, Radio, MultiSelect } from "components";
import agentReportIcon from "assets/images/agent-report.png";
import { getUniqueTransactionTypes, isAgentUser } from "utils/helper";
import terminalReportIcon from "assets/images/terminal-report-icon.svg";

const ReportSelectors = ({
  selectedReport,
  reportOptions,
  handleSelectReport,
  selectedTransactionTypes,
  selectedRegions,
  handleSelectTransTypes,
  handleSelectRegions,
  handleCurrentModalSelect,
}) => {
  const { regions, transactionTypes, user } = useSelector((state) => ({
    user: state.user?.user,
    regions: state.regions.regions,
    transactionTypes: state.transactionsReducer.transactionTypes,
  }));

  const agentReportOptions = [
    {
      label: "Active / Inactive Agents",
      value: "activeInActiveAgents",
    },
    {
      label: "Verified / Unverified Agents",
      value: "verifiedUnverifiedAgents",
    },
    {
      label: "High / Low Performing Agents",
      value: "highLowPerformingAgents",
    },
  ];

  const terminalReportOptions = [
    {
      label: "Terminal Statuses",
      value: "terminalStatuses",
    },
    {
      label: "Inactive / Actively Transacting Terminals",
      value: "activeInActiveTerminals",
    },
    {
      label: "High / Low Performing Terminals",
      value: "highLowPerformingTerminals",
    },
  ];

  const { terminalStatuses, verifiedUnverifiedAgents } = reportOptions;

  if (isAgentUser(user)) terminalReportOptions.shift();

  return (
    <div className="selection-container">
      {" "}
      <div className="d-flex align-items-center ">
        <div className="number-indicator">1</div>
        <Typography variant={"body3"}>
          Choose Report - Select preferred report by checking any of the box
          below
        </Typography>
      </div>
      <div className="terminal-report-select">
        <div className="row">
          {!isAgentUser(user) && (
            <div className="col-md-6">
              <div className="select-header">
                <img src={agentReportIcon} alt="" /> &nbsp; &nbsp;
                <Typography variant="body2" state="primary">
                  Agent Report
                </Typography>
              </div>
              <div className="radio-container">
                {agentReportOptions.map(({ label, value }, key) => (
                  <div key={key}>
                    {" "}
                    <Radio
                      checked={selectedReport === value}
                      checkedState="primary"
                      label={
                        <Typography state="primary" variant="caption1">
                          {label}
                        </Typography>
                      }
                      labelPosition="after"
                      value={value}
                      onClick={() => {
                        handleSelectReport(value);
                        handleCurrentModalSelect(value);
                      }}
                    />
                    <br />{" "}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="col-md-6">
            <div className="select-header">
              <img src={terminalReportIcon} alt="" /> &nbsp; &nbsp;
              <Typography variant="body2" state="primary">
                Terminal Report
              </Typography>
            </div>
            <div className="radio-container">
              {terminalReportOptions.map(({ label, value }, key) => (
                <div key={key}>
                  {" "}
                  <Radio
                    checked={selectedReport === value}
                    checkedState="primary"
                    label={
                      <Typography state="primary" variant="caption1">
                        {label}
                      </Typography>
                    }
                    labelPosition="after"
                    value={value}
                    onClick={() => {
                      handleSelectReport(value);
                      handleCurrentModalSelect(value);
                    }}
                  />
                  <br />{" "}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "4rem" }}>
        <div className="d-flex align-items-center ">
          <div className="number-indicator">2</div>
          <Typography variant={"body3"}>
            {isAgentUser(user) && "Choose Transaction Type"}
            {!isAgentUser(user) &&
            (selectedReport === terminalStatuses ||
              selectedReport === verifiedUnverifiedAgents)
              ? "Choose Region"
              : "Choose Transaction type & Region"}
          </Typography>
        </div>
        <div className="mt-3">
          <div className="row">
            {selectedReport === terminalStatuses ||
            selectedReport === verifiedUnverifiedAgents ? (
              ""
            ) : (
              <div className="col-md-6 mb-4">
                <Typography
                  variant="caption2"
                  state="primary"
                  className={"mb-1"}
                >
                  Select Transaction Type
                </Typography>
                <MultiSelect
                  placeholder={"All Transactions"}
                  className=""
                  value={selectedTransactionTypes}
                  isSearchable={false}
                  clearable={false}
                  handleChange={(val) => {
                    handleSelectTransTypes(val);
                  }}
                  options={getUniqueTransactionTypes(transactionTypes)?.map(
                    ({ type, description }) => ({
                      label: description,
                      value: type,
                    })
                  )}
                  name="transaction-type-select"
                  borderStyle="1.5px solid #E4EAFD"
                />
                <div className="d-flex justify-content-end flex-wrap mb-2">
                  {selectedTransactionTypes?.length &&
                  selectedTransactionTypes?.length ===
                    getUniqueTransactionTypes(transactionTypes)?.length ? (
                    <Typography variant="caption1">
                      All Transaction Types
                    </Typography>
                  ) : (
                    selectedTransactionTypes?.map((region, i) => (
                      <Typography key={i} variant="caption1">
                        {region.label}
                        {i === selectedTransactionTypes?.length - 1
                          ? "."
                          : ","}{" "}
                        &nbsp;
                      </Typography>
                    ))
                  )}
                </div>
              </div>
            )}

            {!isAgentUser(user) && (
              <div className="col-md-6">
                <Typography
                  variant="caption2"
                  state="primary"
                  className={"mb-1"}
                >
                  Select Region
                </Typography>
                <MultiSelect
                  placeholder={"All Regions"}
                  isSearchable={false}
                  clearable={false}
                  value={selectedRegions}
                  options={regions.map((item) => ({
                    label: item.name,
                    value: item.regionCode,
                  }))}
                  handleChange={(val) => handleSelectRegions(val)}
                  borderStyle="1.5px solid #E4EAFD"
                  name="region-select"
                />
                <div className="d-flex justify-content-end flex-wrap mb-2">
                  {selectedRegions?.length &&
                  selectedRegions?.length === regions?.length ? (
                    <Typography variant="caption1">All Regions</Typography>
                  ) : (
                    selectedRegions?.map((region, i) => (
                      <Typography key={i} variant="caption1">
                        {region.label}
                        {i === selectedRegions?.length - 1 ? "." : ","} &nbsp;
                      </Typography>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportSelectors;
